// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Link from "@insite/mobius/Link";
import { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { infoProps } from "@store/Themes/common/props/info";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import React, { useContext } from "react";

export interface OrderDetailsTrackingLinkStyles {
    titleText?: TypographyProps;
    wrapper?: InjectableCss;
    link?: LinkPresentationProps;
}

export const orderDetailsTrackingLinkStyles: OrderDetailsTrackingLinkStyles = {
    titleText: infoProps.label,
};

const styles = orderDetailsTrackingLinkStyles;

const OrderDetailsTrackingLink: React.FunctionComponent = () => {
    const { value: order } = useContext(OrderStateContext);
    const { customSettings } = useSettingsCollection();

    if (!order) return null;

    const trackingUrl = (customSettings as any)?.trackingUrl as string | undefined;
    const orderNumber = order.erpOrderNumber || order.webOrderNumber;

    if (!trackingUrl || !orderNumber) return null;

    const href = `${trackingUrl}?webOrderNumber=${encodeURIComponent(orderNumber)}`;

    return (
        <StyledWrapper {...styles.wrapper} data-test-selector="orderDetailShippingInformation">
            <Typography {...styles.titleText}>{translate("Shipment Tracking")}</Typography>
            <Link
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={translate("View tracking information for order {0}", orderNumber)}
                data-test-selector="orderDetailsTrackingLink"
                {...styles.link}
            >
                {translate("View Tracking Information")}
            </Link>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsTrackingLink,
    definition: {
        allowedContexts: ["OrderDetailsPage"],
        group: "Order Details",
        displayName: "Tracking Link",
    },
};

export default widgetModule;
